import { Battery, BatteryFull, BatteryLow, BatteryMedium } from "lucide-react";
import { getBatteryColorClass, getBatteryWarning } from "@/utils/healthStatus";
import { FieldWarning } from "@/v2/ui/composed/field-warning";

interface BatteryDisplayProps {
  value: number | null | undefined;
  className?: string;
  showWarning?: boolean;
}

export function BatteryDisplay({
  value,
  className = "",
  showWarning = true,
}: BatteryDisplayProps) {
  const colorClass = getBatteryColorClass(value);
  const warning = showWarning ? getBatteryWarning(value) : undefined;
  const Icon =
    value == null
      ? Battery
      : value <= 20
        ? BatteryLow
        : value <= 50
          ? BatteryMedium
          : BatteryFull;

  const content =
    value != null ? (
      `${value}%`
    ) : (
      <span className="tw-text-muted-foreground tw-font-normal tw-italic">
        N/A
      </span>
    );

  return (
    <span
      className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-font-medium ${colorClass} ${className}`}
    >
      <Icon className={`tw-h-4 tw-w-4 tw-flex-shrink-0 ${colorClass}`} />
      {showWarning ? (
        <FieldWarning warning={warning} showIcon={false}>
          {content}
        </FieldWarning>
      ) : (
        content
      )}
    </span>
  );
}
